import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotAuthorized from '../components/Landing/NotAuthorized';

/**
 * URL 파라미터의 group_code와 로그인한 사용자의 group_code가 일치하는지 검사합니다.
 * 일치하지 않으면 NotAuthorized 페이지를 렌더링합니다.
 */
const GroupGuard = ({ children }) => {
  const { group_code } = useParams(); // URL에서 :group_code 파라미터 추출
  const { user } = useSelector((state) => state.auth);

  // 1. URL에 group_code가 있고, 유저 정보가 로드된 상태인 경우 검사 수행
  if (group_code && user) {
    // 2. 루트 관리자(is_root)는 통과 (정책에 따라 변경 가능)
    if (user.is_root) return children; 

    // 3. 그룹 코드가 불일치하면 차단
    if (user.group_code !== group_code) {
      console.warn(`[Security] Unauthorized group access. UserGroup: ${user.group_code}, TargetGroup: ${group_code}`);
      return <NotAuthorized intendedGroupCode={group_code} />;
    }
  }

  // 검사 통과 시 원래 컴포넌트 렌더링
  return children;
};

export default GroupGuard;

